module.exports = __webpack_public_path__ + "img/icon-sphere.e12fd04e.svg";